import { all, put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'react-admin';
import { ActionWithSideEffect } from '../../types';
import {
    COMMENT_CREATE_SUCCESS,
    COMMENT_CREATE_FAILURE,
} from './commentActions';

export default function* commentSaga() {
    yield all([
        takeEvery(COMMENT_CREATE_SUCCESS, function* () {
            yield put(showNotification('resources.comments.created_success'));
        }),
        takeEvery(COMMENT_CREATE_FAILURE, function* ({
            error,
        }: ActionWithSideEffect) {
            yield put(
                showNotification(
                    error || 'resources.comments.created_error',
                    'warning'
                )
            );
            console.error(error);
        }),
    ]);
}
